import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MicroInsurancePage } from './micro-insurance';

@NgModule({
  declarations: [
    MicroInsurancePage,
  ],
  imports: [
    IonicPageModule.forChild(MicroInsurancePage),
  ],
})
export class MicroInsurancePageModule {}



// WEBPACK FOOTER //
// ./src/pages/micro-insurance/micro-insurance.module.ts